module.exports = __webpack_public_path__ + "img/popup-btn-guest.b7b9658.png";